/**
 * Product Item Vue Component
 * ------------------------------------------------------------------------------
 * Main template in snippets/product-item.liquid
 */

import { product } from '../mixins/product.js'

export default {
  mixins: [
    product
  ],

  data () {
    return {
      isLoading: false
    }
  },

  created () {
    if (this.product.variants && this.product.variants.length > 0) {
      this.currentVariant = this.product.variants[0]
    }

    this._initSelectedOptions()
  }
}
